import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { useAccount } from '../../contexts/Account';
import CompanyPreferences from '../AccountSettings/CompanyPreferences';
import EditButton from './EditButton';
import FilePondProfile from '../ProfileUploaderFreemium/onlyDisplay';

const useStyles = (isSM) => ({
  card: {
    maxWidth: '1200px',
    width: '100%',
  },
  companyInformationSectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    paddingBottom: '5px',
  },
  title: {
    fontWeight: 'bold',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingRight: '20px',
  },
  profileInformationContainer: {
    height: '120px',
    marginTop: '20px',
    marginBottom: '15px',
    display: 'flex',
    flexDirection: 'row',
  },
  profileImage: {
    width: '120px',
    height: '120px',
    borderRadius: '120px',
    marginRight: '20px',
  },
  profileDetails: {
    display: 'flex',
    flexDirection: 'column',
    height: '120px',
    justifyContent: 'space-between',
    marginLeft: '10px',
    marginTop: '5px',
  },
  topTitle: {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '-0.43px',
    color: '#232B35',
    marginTop: '15px',
  },
  longText: {
    whiteSpace: 'pre-wrap',
  },
  subtitle: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: '400',
    color: '#232B35',
    fontStyle: 'normal',
    fontWeight: 700,
    letterSpacing: -0.43,
  },
  section: {
    border: 'solid 1px #E5E5E5',
    borderRadius: '10px',
    padding: '20px',
    marginBottom: '20px',
  },
  subtitleDescription: {
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: '400',
    color: '#646D7A',
    fontStyle: 'normal',
    fontWeight: 500,
    letterSpacing: -0.43,
    paddingBottom: '20px',
    marginTop: '10px',
  },
});

function CompanyInformationViewFreemiumCard({ isSM, onEditClick }) {
  const classes = useStyles(isSM);
  const { accountDetails } = useAccount();
  const yourInformation = accountDetails.userData;

  return (
    <Paper elevation={0} sx={classes.card}>
      <div style={classes.companyInformationSectionContainer}>
        <Box sx={{ ...classes.section }}>
          <div style={classes.row}>
            <Typography
              variant="body1_old_font"
              sx={{ ...classes.title, ...classes.subtitle }}
            >
              About you
            </Typography>
            {yourInformation.isBoardOwner && (
              <EditButton onClick={onEditClick} fremiumView />
            )}
          </div>

          <div style={classes.profileInformationContainer}>
            <FilePondProfile />
            <div style={classes.profileDetails}>
              <Typography variant="body1_old_font">{`${yourInformation.givenName} ${yourInformation.surName}`}</Typography>
              {yourInformation.title && yourInformation.title.length > 0 && (
                <Typography variant="body1_old_font">
                  {yourInformation.title}
                </Typography>
              )}
              <Typography variant="body1_old_font">
                {yourInformation.email}
              </Typography>
              <Typography variant="body1_old_font">
                {yourInformation.phoneNumber &&
                yourInformation.phoneNumber.phoneNumber &&
                yourInformation.phoneNumber.phoneNumber !== '5555555555'
                  ? yourInformation.phoneNumber.phoneNumber
                  : ''}
              </Typography>
            </div>
          </div>
          {yourInformation.biography &&
            yourInformation.biography.length > 0 && (
              <Typography
                variant="body1_old_font"
                sx={{ ...classes.topTitle, marginTop: '10px' }}
              >
                Biography
              </Typography>
            )}
          <pre style={classes.longText}>
            <Typography variant="body1_old_font">
              {yourInformation.biography}
            </Typography>
          </pre>
        </Box>
        <Box sx={classes.section}>
          <CompanyPreferences freemiumView hideBillingInformation />
        </Box>
        <Box sx={classes.section}>
          <CompanyPreferences freemiumView hidePlanDetails />
        </Box>
      </div>
    </Paper>
  );
}

export default CompanyInformationViewFreemiumCard;
